module.exports = __webpack_public_path__ + "static/media/leaf.519d3e1c.png";